import type { Services, JustText, SubtopicDetails } from "../data-types/data-types"

type Coaching = {
    details: JustText[],
}

export const topicsCovered: SubtopicDetails[] = [
    {
        id: 1,
        title: 'Laziness',
        notes: [
            `If your child's slothfulness irritates you, and you've tried everything in your power without changes, then, SMARTA Teens Coaching is all your child needs.`,
            `They can overcome procrastination, along with laziness, lethargy, and low-effort syndrome, giving your teen a chance to develop positive life habits honoring their potential. They'll find it easy to achieve real happiness and success.`
        ]
    },
    {
        id: 2,
        title: 'Academic Difficulties',
        notes: [
            `Is your teen struggling with school?`,
            `SMARTA Coaching program is designed to help teens overcome their academic challenges by identifying, understanding, and working on the roots of the cause of poor school performance. It provides a proven solution with practical tools and strategies that can be used at home, in school, or in other settings to boost grades and improve academic performance.`
        ]
    },
    {
        id: 3,
        title: 'Pornography',
        notes: [
            `65% of boys and 30% of girls admit to viewing pornography. It is a serious issue affecting millions of teens. Even as a parent, it may feel like you're fighting a losing battle. Be aware that some of the teens who seem to have everything together are also addicted to porn.`,
            `Studies also show that 90% of boys, and 60% of girls, also feel guilty, and want to stop watching pornography and masturbating, but are unable to without help.`,
            `Our 8 - weeks coaching program tackles and solves the issue of pornography from a holistic perspective, including physical, mental, emotional, and social symptoms caused by addiction to internet pornography and masturbation.`
        ]
    },
    {
        id: 4,
        title: 'Behavioural Issues',
        notes: [
            `A recent study showed that more than 80% of teenagers suffer from behavioral issues, but only a few of them can actually get help from qualified coaches.`,
            `SMARTA Behavioural Coaching is an 8-week comprehensive course delivered to students via a variety of group learning, action-based activities, and 1-2-1 sessions with the SMARTA expert coach.`,
            `Our proven system will provide your teen with the skills to inhibit urges and visualize appropriate responses.`,
            `The program covers all behavioral issues, Feelings of anxiety and low self-esteem, Phone addiction, Lying to parents or friends, cyber-bullying, acting out, problems with violence, etc.`
        ]
    },

]

export const services: Services[] = [
    {
        id: 1,
        title: 'SMARTA Mentorship',
        notes: [
            `Teens are impressionable. They unknowingly learn from their peers and others who expose them to negative behaviors that may have harmful effects on them as they progress into adulthood. But with the right guidance, your teen will develop self-confidence, better school performance and harmful behaviors are minimized or eliminated.`,
            `Eighty-five percent (85%) of teens who meet one-on-one with a mentor once a week have higher grades and fewer behavior problems. Also, 57% of teens who are actively mentored feel confident they can succeed in the adult world.`,
            `At SMARTA, we help teens develop social-emotional skills (one of their greatest challenges) through our custom mentorship program. Our mentors will work with your teen on developing more self-awareness, setting goals, solving problems, applying critical thinking skills, making better choices for their future, and understanding social relationships at school and elsewhere.`,
            `Please, do your teen a favor and sign them up for SMARTA Mentorship.`
        ]
    },
    {
        id: 2,
        title: 'SMARTA Book Club',
        notes: [
            `Are you worried about your teen's social skills? Concerned they may be left out of the loop due to their inability to communicate with their peers? Teens readily learn the most from others their age, and through SMARTA Book Club, teens are able to share their struggles and triumphs in order to connect with one another.`,
            `Our book club is a peer-based interactive community that optimizes the power of group dynamics within a controlled environment. Your teen will discover a path to greater social connectedness, and learn skills like effective communication, conflict resolution, negotiation, and time management.`,
            `SMARTA Teens Book Club enables teens an opportunity to get out of their shells, interact with fellow progressive, like-minded teenagers, and learn the social skills they need to be successful later in life.`
        ]
    },
    {
        id: 3,
        title: 'SMARTA Coaching',
        notes: [
            `Many studies have shown that the adolescent years can be the most critical in terms of creating future success for a teenager. During adolescence, things get so hard that many teens give up. They face conflicting demands between their parents, teachers, and friends. The messages they get through the media and from other sources, like internet forums and social sites, only confuse them more.Unfortunately, the prefrontal cortex of the brain which helps in learning self-control, exercising self-discipline, and coping with everyday challenges is not well developed yet. So, their world quickly becomes a place of great confusion and stress. They, unfortunately, pick up bad habits that negatively affect their future and stress their parents out.`,
            `At SMARTA, our coaching programs are tailored to help save your teenager and guide them through these important teen years. As described by our previous clients, our programs are life-changing, empowering and refreshing.`,
            `Our 2-month transformative program is a unique blend of live coaching, mentoring, engaging activities, and accountability, using the latest psychological techniques and educational methods.`,
        ],
        subtopic: {
            heading: "List of topics covered by our coaching programs.",
            details: topicsCovered
        }
    },
]


export const coaching: Coaching = {
    details: [

        {
            id: 1,
            text: 'Comprehensive coaching sessions',
            count: '8'
        },
        {
            id: 2,
            text: 'Focused and engaging HomeWorks and activities',
            count: '8'
        },
        {
            id: 3,
            text: 'Weeks accountability follow-up',
            count: '8'
        },
        {
            id: 4,
            text: 'Weeks access to SMARTA Mentorship Program',
            count: '8'
        },
        {
            id: 5,
            text: 'Weeks access to SMARTA Book Club',
            count: '8'
        },
        {
            id: 6,
            text: 'Short course on parenting teens',
            count: '1'
        },
        {
            id: 7,
            text: 'Printable workbook (PDF)',
            count: '1'
        },
        {
            id: 8,
            text: 'SMARTA Teens Journal',
            count: '1'
        },
        {
            id: 9,
            text: 'Parent-coach update sessions',
            count: '2'
        },
        {
            id: 10,
            text: 'Hours access to your teen’s progress report',
            count: '24'
        },
    ],
}